/* eslint-disable no-underscore-dangle */
import { applyMiddleware, compose, createStore } from 'redux'
import onStateChange from 'redux-on-state-change'
import { createStateSyncMiddleware } from 'redux-state-sync'
import thunk from 'redux-thunk'

import * as cartActions from 'features/cart/cart-overview/duck/actions'

import handleOnStateChange from './middlewares/pubSub'
import rootReducer from './root-reducer'

const syncConfig = {
  whitelist: [
    ...Object.keys(cartActions).reduce(
      (accumulator, key) => [...accumulator, cartActions[key].getType()],
      [],
    ),
  ],
}

const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })) ||
  compose

export const middlewares = [
  !window.disableSyncMiddleware && createStateSyncMiddleware(syncConfig),
  thunk,
  onStateChange(handleOnStateChange),
].filter((middleware) => !!middleware)

const enhancer = composeEnhancers(applyMiddleware(...middlewares))

function configureStore(initialState): any {
  return createStore(rootReducer, initialState, enhancer)
}
export default configureStore
